import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { Angular2Csv } from 'angular2-csv/Angular2-csv';

interface CashflowAnalysisInterface {
  capex?: any;
  depreciation?: any;
  ebit?: any;
  freeCashFlow?: any;
  nopat?: any;
  revenue?: any;
  taxation?: any;
  workingCapital?: any;
  discountCashFlow?: any;
  discountFactor?: any;
  freeCashFlowDays?: any;
  terminalCashFlow?: number;
  terminalDcf?: number;
  terminalValueFactor?: number;
}

@Component({
  selector: 'cashflow-analysis',
  templateUrl: 'cashflow-analysis.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CashflowAnalysisComponent {

  @Input() cashFlowAnalysis: CashflowAnalysisInterface;
  @Input() loading: boolean;
  @Input() hideFooter: boolean;
  rows: any;
  columns: any;

  constructor() {
  }

  ngOnChanges(changes: any) {

    this.rows = this.getRows(this.cashFlowAnalysis);
    this.columns = this.getColumns(this.rows);

  }
  outputCsv() {
    const headers = Object.keys(this.columns).map(id => this.columns[id].prop);
    const newData = this.rows.map(row => headers.map(id => row[id]));
    headers[0] = '';

    new Angular2Csv(newData, `Cashflow Analysis ${new Date().getTime()}`, { headers });
  }

  private getRows(cashFlowAnalysis) {
    const rows = [
      { name: "Revenue", id: 'revenue' },
      { name: "EBIT", id: 'ebit' },
      { name: "Tax", id: 'taxation' },
      { name: "Depreciation", id: 'depreciation' },
      { name: "Capex", id: 'capex' },
      { name: "Working Capital", id: 'workingCapital' },
      { name: "Free Cash Flow", id: 'freeCashFlow' },
      { name: "Discount Factor", id: 'discountFactor' },
      { name: "DCF", id: 'discountCashFlow' },
    ];
    rows.forEach(row => {
      cashFlowAnalysis[row.id].forEach(element => {
        if (row.id == 'discountFactor') {
          row[element.year] = parseFloat(element.value).toFixed(1);
        } else {
          row[element.year] = parseFloat(element.value).toFixed(0);
        }
      });
    });
    return rows;
  }
  private getColumns(rows) {
    const columns: any = [
      { prop: "name", name: "&nbsp;" }
    ];
    Object.keys(rows[0]).forEach(key => {
      (key !== 'id' && key !== 'name') && columns.push({
        prop: key,
        width: 70
      });
    });
    return columns;
  }
}



// WEBPACK FOOTER //
// ./src/components/cashflow-analysis/cashflow-analysis.ts